import Cart from "cart-store";

class FreeShippingBar extends HTMLElement {
  #animationInterval = null;
  #boundOrchestrateModalEvent;
  #parentModal;
  #playingAnimation;

  constructor() {
    super();
    // ✅ Private method bind
    this.#boundOrchestrateModalEvent = this.#orchestrateModalEvent.bind(this);
    this.minimumValue = Number(this.getAttribute("minimum-value")) || 0;
    this.value = Number(this.getAttribute("value")) || 0;
    this.discountPercent = (this.getAttribute("discount-percent") || "10").replace("%", "").trim();
  }

  async connectedCallback() {
    this.amountToSpendElement = this.querySelector("cart-amount-to-spend");
    this.amountLeftElement = this.querySelector("cart-amount-left");
    this.minimumReachedElement = this.querySelector("cart-minimum-reached");
    this.track = this.querySelector("cart-discount-qty-bar-track");
    this.goalAnimation = null;
    this.#playingAnimation = false;

    this.#parentModal = this.closest("modal-dialog, popup-dialog");
    this.#setVariables();

    // ===== Subscribe to cart updates =====
    // this.unsubscribe = Cart.subscribe((state) => {
    //   const cartItemsCollections = this.getCartItemsCollections();
    //   console.log(cartItemsCollections)

    //   let count = 0;
    //   state.cart.items.forEach((item) => {
    //     const collections = cartItemsCollections[item.id] || [];
    //     const hasMisfit = collections.some(c => c && c.handle === 'misfit-tees');
    //     if (!hasMisfit) count += item.quantity;
    //   });

    //   const newValue = count;

    //   if (this.value !== newValue) {
    //     this.value = newValue;
    //     this.#update();
    //   }

    //   if (this.value >= this.minimumValue) {
    //     this.track.addEventListener(
    //       "transitionend",
    //       () => setTimeout(() => this.#playGoalAnimation(), 250),
    //       { once: true }
    //     );
    //   }
    // });

    this.unsubscribe = Cart.subscribe(async (state) => {  // async added
      const cartItemsCollections = await this.getCartItemsCollections(); // await added
      // console.log(cartItemsCollections);

      let count = 0;
      state.cart.items.forEach((item) => {
        const collections = cartItemsCollections[item.id] || [];
        const isMisfit = collections.some(c => c && c.handle === 'misfit-tees');
        if (!isMisfit) count += item.quantity; // misfit items only
      });

      const newValue = count;

      if (this.value !== newValue) {
        this.value = newValue;
        this.#update();
      }

      if (this.value >= this.minimumValue) {
        this.track.addEventListener(
          "transitionend",
          () => setTimeout(() => this.#playGoalAnimation(), 250),
          { once: true }
        );
      }
    });


    this.revealDelay = this.getAttribute("reveal-delay") || 0;

    // ===== Handle modal / scroll reveal =====
    if (this.#parentModal) {
      this.#parentModal.addEventListener("on:modal:opened", this.#boundOrchestrateModalEvent);
      this.#parentModal.addEventListener("on:modal:closed", this.#boundOrchestrateModalEvent);
    } else {
      const options = { rootMargin: "0px", threshold: 0.95 };
      this.visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          setTimeout(() => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              setTimeout(() => {
                if (this.amountLeft === 0) this.#playGoalAnimation();
              }, 500);
              this.visibilityObserver.disconnect();
            }
          }, this.revealDelay);
        });
      }, options);
      this.visibilityObserver.observe(this);
    }

    // ===== Load animation =====
    const goalAnimationElement = this.querySelector("cart-discount-qty-bar-goal-animation");
    if (goalAnimationElement) {
      const { DotLottie } = await import("dotlottie");
      const loadAnimation = () => {
        this.goalAnimation = new DotLottie({
          canvas: goalAnimationElement.querySelector("canvas"),
          loop: false,
          autoplay: false,
          src: goalAnimationElement.getAttribute("data-url"),
        });
      };
      if (this.#parentModal) {
        this.#parentModal.on("on:modal:opening", loadAnimation, { once: true });
      } else {
        loadAnimation();
      }
    }
  }

  disconnectedCallback() {
    this.classList.remove("is-visible");
    if (this.visibilityObserver) this.visibilityObserver.disconnect();
    if (this.#parentModal) {
      this.#parentModal.removeEventListener("on:modal:opened", this.#boundOrchestrateModalEvent);
      this.#parentModal.removeEventListener("on:modal:closed", this.#boundOrchestrateModalEvent);
    }
    if (this.unsubscribe) this.unsubscribe();
    if (this.#animationInterval) clearInterval(this.#animationInterval);
  }

  // ===== Helper: fetch latest cart items collections from Liquid section =====
  async getCartItemsCollections() {
  const cart_collections_html = await fetch('/?sections=cart_collections')
    .then(res => res.json())
    .then(data => data.cart_collections)
    .catch(err => { console.warn(err); return null; });
// console.log("cart_collections_html :: ", cart_collections_html)
  if (!cart_collections_html) return {};

  // ✅ Parse HTML string into DOM
  const parser = new DOMParser();
  const doc = parser.parseFromString(cart_collections_html, 'text/html');

  const dataElement = doc.getElementById('cart-collections-data');
  if (!dataElement) return {};

  const jsonData = JSON.parse(dataElement.textContent);
  const result = {};

  jsonData.items.forEach(item => {
    result[item.id] = item.collections;
  });

  return result;
}


  #setVariables() {
    this.amountLeft = Math.max(this.minimumValue - this.value, 0);
    this.displacement = Math.round((this.value / this.minimumValue) * 100);
  }

  #update() {
    this.setAttribute("value", this.value);
    this.#setVariables();

    this.track.style.setProperty("--displacement", `calc(100% - ${this.displacement}%)`);

    if (this.amountLeft > 0) {
      const plural = this.amountLeft > 1 ? "items" : "item";
      this.amountLeftElement.textContent = `Pick any ${this.amountLeft} more ${plural} and save ${this.discountPercent}%`;
    }

    // Visibility
    if (this.value === 0) {
      this.amountToSpendElement.removeAttribute("hidden");
      this.amountLeftElement.setAttribute("hidden", "");
      this.minimumReachedElement.setAttribute("hidden", "");
    } else if (this.amountLeft > 0) {
      this.amountToSpendElement.setAttribute("hidden", "");
      this.amountLeftElement.removeAttribute("hidden");
      this.minimumReachedElement.setAttribute("hidden", "");
    } else {
      this.amountToSpendElement.setAttribute("hidden", "");
      this.amountLeftElement.setAttribute("hidden", "");
      this.minimumReachedElement.removeAttribute("hidden");
    }
  }

  #playGoalAnimation() {
    const goalAnimationElement = this.querySelector("cart-discount-qty-bar-goal-animation");
    const animationShown = Boolean(localStorage.getItem("cartDiscountAnimationShown"));
    if (!goalAnimationElement || animationShown || this.#playingAnimation) return;
    this.#playingAnimation = true;

    this.#animationInterval = setInterval(() => {
      if (this.goalAnimation && this.goalAnimation.isLoaded) {
        clearInterval(this.#animationInterval);
        this.#animationInterval = null;

        const canvas = goalAnimationElement.querySelector("canvas");
        if (canvas.getAttribute("width") === "0") {
          canvas.setAttribute("width", 300);
          canvas.setAttribute("height", 300);
        }

        localStorage.setItem("cartDiscountAnimationShown", true);
        this.goalAnimation.play();
      }
    }, 100);
  }

  #orchestrateModalEvent(e) {
    if (e.type === "on:modal:opened") {
      this.classList.add("is-visible");
    } else if (e.type === "on:modal:closed") {
      this.classList.remove("is-visible");
    }
  }
}

customElements.define("cart-discount-qty-bar", FreeShippingBar);
